import { render, staticRenderFns } from "./text-input.vue?vue&type=template&id=50b32d85"
import script from "./text-input.vue?vue&type=script&lang=js"
export * from "./text-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b32d85')) {
      api.createRecord('50b32d85', component.options)
    } else {
      api.reload('50b32d85', component.options)
    }
    module.hot.accept("./text-input.vue?vue&type=template&id=50b32d85", function () {
      api.rerender('50b32d85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/message-control/text-input.vue"
export default component.exports